import { mutation } from '1_shared/api/apiInstance';

import { SpecialistListInput } from './interfaces/SpecialistListInput';
import { SpecialistListOutput } from './interfaces/SpecialistListOutput';


export const getSpecialistList = mutation<SpecialistListInput, SpecialistListOutput>()